import { useCallback } from 'react';

interface TokenBalance {
  symbol: string;
  balance: string;
}

interface UseMaxBalanceProps {
  publicTokens: TokenBalance[];
  privateTokens: TokenBalance[];
  selectedPublicToken: string | null;
  selectedPrivateToken: string | null;
  /** @deprecated Unused — fee reservation is handled in AmountInputModal. Kept for call-site compat. */
  localDirection?: 'to-private' | 'to-public';
  /** @deprecated Unused — fee reservation is handled in AmountInputModal. Kept for call-site compat. */
  estimatedGasFee?: string | null;
}

export const useMaxBalance = ({
  publicTokens,
  privateTokens,
  selectedPublicToken,
  selectedPrivateToken,
}: UseMaxBalanceProps) => {
  const getSelectedTokenBalance = useCallback(() => {
    let balance = 0;

    if (selectedPublicToken) {
      const token = publicTokens.find((t) => t.symbol === selectedPublicToken);
      balance = token ? parseFloat(token.balance) : 0;
    } else if (selectedPrivateToken) {
      const token = privateTokens.find((t) => t.symbol === selectedPrivateToken);
      balance = token ? parseFloat(token.balance) : 0;
    }

    // Return the raw wallet balance. COTI Portal In fee reservation lives in
    // AmountInputModal (portalFeeAtMax / effectiveMaxAmount). Subtracting gas
    // here too made maxAmount shrink when fees re-estimated after Max, which
    // falsely showed "Insufficient balance" on the first Max click.
    return balance;
  }, [
    publicTokens,
    privateTokens,
    selectedPublicToken,
    selectedPrivateToken,
  ]);

  return { getSelectedTokenBalance };
};
